module.exports = __webpack_public_path__ + "img/romantic@2x.9d4f7eb.webp";